// extracted by mini-css-extract-plugin
export default {"dropdownBox":"style_dropdownBox__nE0CV","box":"style_box__LAqBW","active":"style_active__Fu7Y4","title":"style_title__+knX6","item":"style_item__DF1B8"};